const onlinePaymentTypesEnabledPerCountry = {
  ar: ['Decidir', 'Spreedly AR'],
  bo: ['Ingenico BO', 'Spreedly BO'],
  do: ['Spreedly DO'],
  co: ['Spreedly CO'],
  cl: ['MercadoPago', 'WebPay CL', 'Spreedly CL', 'Oneclick CL'],
  cr: ['Ingenico CR', 'Spreedly CR'],
  pa: ['Ingenico PA', 'Spreedly PA'],
  py: ['Ingenico PY', 'Spreedly PY'],
  ve: ['Spreedly VE'],
  ec: ['Spreedly EC'],
  pe: ['Spreedly PE'],
  uy: [
    'VisaNet',
    'OCA',
    'Mastercard UY',
    'Ticket Restaurant Online',
    'Ticket Alimentación Online',
    'Creditel UY',
    'Spreedly UY',
  ],
  sv: ['Spreedly SV'],
  gt: ['Spreedly GT'],
  hn: ['Spreedly HN'],
};

const AVAILABLE_ONLINE_PAYMENT_TYPES = [
  'VisaNet',
  'MercadoPago',
  'Ticket Restaurant Online',
  'Ticket Alimentación Online',
  'Decidir',
  'OCA',
  'Mastercard UY',
  'Ingenico PA',
  'Ingenico PY',
  'Ingenico CR',
  'Ingenico BO',
  'WebPay CL',
  'Creditel UY',
  'Spreedly DO',
  'Spreedly CL',
  'Spreedly CO',
  'Spreedly UY',
  'Spreedly AR',
  'Spreedly BO',
  'Spreedly PA',
  'Spreedly PY',
  'Spreedly VE',
  'Oneclick CL',
  'Spreedly EC',
  'Spreedly PE',
  'Spreedly CR',
  'Spreedly SV',
  'Spreedly GT',
  'Spreedly HN',
];

function getEnabledOnlinePaymentTypes(country) {
  return (
    onlinePaymentTypesEnabledPerCountry[country] ||
    AVAILABLE_ONLINE_PAYMENT_TYPES
  );
}

module.exports = {
  getEnabledOnlinePaymentTypes,
  AVAILABLE_ONLINE_PAYMENT_TYPES,
};
